import { useEffect, useRef } from "react";
import { trpc } from "@/lib/trpc";

/** Clínica que ficou sem procedimentos montados (do tempo do passo de onboarding, que saiu): monta
 *  sozinha, com os das especialidades que ela já tem, na primeira entrada de quem gerencia. */
export function useMontarProcedimentosPendentes(precisa: boolean) {
  const utils = trpc.useUtils();
  const feito = useRef(false);
  const montar = trpc.clinicaOnboarding.montarAutomatico.useMutation({
    onSuccess: () => {
      utils.me.current.invalidate();
      utils.service.invalidate();
      utils.organization.activeSpecialties.invalidate();
    },
  });
  useEffect(() => {
    if (!precisa || feito.current) return;
    feito.current = true;
    montar.mutate();
  }, [precisa, montar]);
}
